/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import saveAs from 'file-saver';
import JSZip from 'jszip';

import { v4 as uuidv4 } from 'uuid';

import {
  CatalogOrderFileItem,
  CatalogOrderFileItemCustomAttributeValue,
  CatalogOrderFileItemCustomAttributesValues,
  CatalogOrderFileItemOption,
  CatalogOrderFileRoot,
  OrderSessionData,
} from '../../common/libraries/fileFormats/catalogOrder/catalogOrder';
import {
  TimeUtil,
} from '../../common/libraries/time/timeUtil';

import { CustomAttributeValue } from '../../common/libraries/customAttributes/customAttributeValue';

import { CartItem, CartItemHelper } from '../Data/CartItem';
import { Customization } from '../../common/libraries/modelViewer/Data/Customization';
import { CustomizationConfiguration } from '../../common/libraries/modelViewer/Data/CustomizationConfiguration';
import { CustomizationsOutputFile } from '../Data/CustomizationsOutputFile';
import { CustomizationValue } from '../Data/CustomizationValue';
import { CustomizationValueDataImage } from '../Data/CustomizationValueDataImage';
import { IDocumentOrderGeneratorEnvironmentSettings } from '../Data/DocumentOrderGeneratorEnvironmentSettings';

import { FileUtil } from '../Util/FileUtil';
import { PickedFilesHandler } from '../Util/PickedFilesHandler';
import { readFileAsync } from '../Util/ReadFileHelper';

import { Strings } from '../../Resources/Strings/Strings';
import { OrderDocumentPDFGenerator } from './OrderDocumentPDFGenerator';
import { POSCatalogData, POSCatalogModelData } from '../../common/libraries/modelViewer/Data/POSCatalogData';
import { RequestOrderInsert, ResponseOrderInsert } from '../../common/libraries/requests/orders/requestOrderInsert';
import { EvaluatedProperties } from '../../common/libraries/modelConfiguration/data/evaluatedProperties';
import { ModelRuleType } from '../../common/libraries/modelConfiguration/rules/modelRuleType';
import { RulesEvaluationProperties } from '../../common/libraries/modelConfiguration/rules/rulesEvaluationProperties';
import { SLTXDefaultFolderName } from '../../common/libraries/fileFormats/sltx/sltx';
import { RequestCatalogLogin, ResponseCatalogLogin } from '../../common/libraries/requests/users/requestCatalogLogin';
import { RequestChannelPasswordReset } from '../../common/libraries/requests/users/requestChannelPasswordReset';
import { RequestChannelPasswordChange } from '../../common/libraries/requests/users/requestChannelPasswordChange';
import { CatalogTagsTranslation } from '../../common/libraries/modelViewer/Data/catalogTagsTranslation';
import { POS_BACKEND_PORT } from '../../globals/constants';

import { PriceData, PriceDataHelpers } from '../../common/libraries/fileFormats/catalog/catalog';
import { CustomAttributeData } from '../../common/libraries/customAttributes/customAttributes';
import { CustomAttributeClassPrefix } from '../../common/libraries/customAttributes/customAttributesClassPrefix';
import { FilePaths } from '../../common/libraries/fileSystem/filePaths';
import { SLTXFile } from '../../common/libraries/fileFormats/sltx/sltxFile';

interface NameAndTranslation {
  name: string;
  translatedName: string;
}
export class POSOrderManager {

  public static async authenticate(
    userName : string,
    password : string,
    channelName : string,
    catalogKey: string,
    backendUrl: string,
  ) : Promise<string> {
    // const channelBackendInsertOrderEndpoint = catalog.catalogFileInfo.sourceData;
    const request = new RequestCatalogLogin();
    const urlComponents = window.location.href.split(':', 2);
    const url = backendUrl || `${urlComponents[0]}:${urlComponents[1]}:${POS_BACKEND_PORT}`;
    const endpoint = new URL(request.getAPIEndPoint(), url).toString();

    console.log(`Calling ${endpoint}`);

    request.catalogKey = catalogKey;
    request.channel = channelName;
    request.user = userName;
    request.channelPassword = password;

    // Setup the endpoint, using the request information
    try {

      // Convert the contents of the request to string
      const bodyContents = JSON.stringify(request);

      // Configure and perform the request
      const response = await fetch(
        endpoint,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: bodyContents,
        },
      );

      // Convert the response to the expected type
      const reqResponse = await response.json() as ResponseCatalogLogin;

      return reqResponse.tokenData;

    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Some issue when sending the order to the backend', error);
      return '';
    }
  }

  public static async resetPassword(
    userName : string,
    channelName : string,
    backendUrl: string,
  ) : Promise<boolean> {
    // const channelBackendInsertOrderEndpoint = catalog.catalogFileInfo.sourceData;
    const request = new RequestChannelPasswordReset();

    const urlComponents = window.location.href.split(':', 2);
    const url = backendUrl || `${urlComponents[0]}:${urlComponents[1]}:${POS_BACKEND_PORT}`;
    const endpoint = new URL(request.getAPIEndPoint(), url).toString();

    console.log(`Calling ${endpoint}`);

    request.channelName = channelName;
    request.userName = userName;

    // Setup the endpoint, using the request information
    try {

      // Convert the contents of the request to string
      const bodyContents = JSON.stringify(request);

      // Configure and perform the request
      const response = await fetch(
        endpoint,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: bodyContents,
        },
      );

      // Convert the response to the expected type
      const reqResponse = await response.json() as ResponseCatalogLogin;

      return reqResponse.result;

    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Some issue when sending the order to the backend', error);
      return false;
    }
  }

  public static async changePassword(
    userName : string,
    channelName : string,
    oldPassword: string,
    newPassword: string,
    newPasswordCopy: string,
    backendUrl: string,
  ) : Promise<boolean> {

    if (newPassword !== newPasswordCopy) {
      return false;
    }
    const request = new RequestChannelPasswordChange();

    const urlComponents = window.location.href.split(':', 2);
    const url = backendUrl || `${urlComponents[0]}:${urlComponents[1]}:${POS_BACKEND_PORT}`;
    const endpoint = new URL(request.getAPIEndPoint(), url).toString();

    request.channelName = channelName;
    request.userName = userName;
    request.oldPassword = oldPassword;
    request.newPassword = newPassword;

    // Setup the endpoint, using the request information
    try {

      // Convert the contents of the request to string
      const bodyContents = JSON.stringify(request);

      // Configure and perform the request
      const response = await fetch(
        endpoint,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: bodyContents,
        },
      );

      // Convert the response to the expected type
      const reqResponse = await response.json() as ResponseCatalogLogin;

      return reqResponse.result;

    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Some issue when sending the order to the backend', error);
      return false;
    }
  }

  public static async handleOrderCreation(
    sessionToken : string,
    cartItems : CartItem[],
    customAttributesValues : CustomAttributeValue[],
    catalog: POSCatalogData,
    pickedFilesHandler : PickedFilesHandler,
    strings : Strings,
    language : string,
    environmentSettings : IDocumentOrderGeneratorEnvironmentSettings,
    translations : CatalogTagsTranslation[],
    orderSessionData: OrderSessionData,
  ) : Promise<boolean> {

    if (catalog.catalogFileInfo === undefined) {
      return false;
    }
    // Generate the order data
    // eslint-disable-next-line max-len
    const orderData = await POSOrderManager.generateOrderData(environmentSettings, cartItems, customAttributesValues, catalog, orderSessionData, language);
    // Check if the order data was generated
    if (orderData === undefined) {
      return false;
    }

    orderData.language = language.toLowerCase();

    // Try to send the order data to the backend
    const { channelBackendInsertOrderEndpoint } = catalog.catalogFileInfo.sourceData;

    const orderWasCreatedInBackend = await POSOrderManager.sendOrderDataToBackend(
      orderData,
      sessionToken,
      channelBackendInsertOrderEndpoint,
      language,
    );

    // Generate the order files
    // POSOrderManager.generateOrderFiles(
    //   orderWasCreatedInBackend,
    //   orderData,
    //   cartItems,
    //   customAttributesValues,
    //   catalog,
    //   pickedFilesHandler,
    //   strings,
    //   environmentSettings,
    //   language,
    //   translations,
    // );

    return orderWasCreatedInBackend;
  }

  private static async sendOrderDataToBackend(
    orderData : CatalogOrderFileRoot,
    sessionToken : string,
    backendUrlOrderCreation : string | undefined,
    language : string,
  ) : Promise<boolean> {
    try {

      const request = new RequestOrderInsert();
      request.sessionToken = sessionToken;
      request.orderData = orderData;
      request.language = language.toLowerCase();

      // Setup the endpoint, using the request information
      const urlComponents = window.location.href.split(':', 2);
      const url = backendUrlOrderCreation || `${urlComponents[0]}:${urlComponents[1]}:${POS_BACKEND_PORT}`;
      const endpoint = new URL(request.getAPIEndPoint(), url).toString();

      // Convert the contents of the request to string
      const bodyContents = JSON.stringify(request);

      // Configure and perform the request
      const response = await fetch(
        endpoint,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: bodyContents,
        },
      );

      // Convert the response to the expected type
      const reqResponse = await response.json() as ResponseOrderInsert;
      return reqResponse.result;

    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Some issue when sending the order to the backend');
      return false;
    }
  }

  // Needs to be based on CatalogOrderFileRoot (i.e. the actual order)
  public static async generateOrderPDFDocument(
    uniqueFileName : string,
    cartItems : CartItem[],
    customAttributesValues : CustomAttributeValue[],
    catalog: POSCatalogData,
    strings : Strings,
    environmentSettings : IDocumentOrderGeneratorEnvironmentSettings,
    orderSessionData: OrderSessionData,
    language : string,
    bShowPrice: boolean,
    orderPreviewFontSize: number,
    orderPreviewImageWidth: number,
    orderEndCustNameAttrName: string,
  ) {
    console.log(`Generating order PDF: ${catalog.catalogFileInfo?.sourceData.catalogName}  lang=${language}`);
    const orderData = await this.generateOrderData(
      environmentSettings,
      cartItems,
      customAttributesValues,
      catalog,
      orderSessionData,
      language,
    );
    console.log(`Order data generated: ${JSON.stringify(cartItems)}`);

    if (orderData) {
      const pdfBlob = await OrderDocumentPDFGenerator.CreateOrderDataDocument(
        uniqueFileName,
        orderData,
        catalog,
        strings,
        environmentSettings,
        bShowPrice,
        orderPreviewFontSize,
        orderPreviewImageWidth,
        orderEndCustNameAttrName,
      );
      return pdfBlob;
    }
    return undefined;
  }

  private static getModelOptionPrice(
    environmentSettings: IDocumentOrderGeneratorEnvironmentSettings,
    priceData: Array<PriceData>,
    modelName: string,
    groupName: string,
    optionName: string,
  ): number {
    const priceInfo = PriceDataHelpers.getOptionPrice(priceData, modelName, groupName, optionName);
    if (!priceInfo) {
      return 0;
    }
    return priceInfo;
  }

  public static async generateOrderData(
    environmentSettings: IDocumentOrderGeneratorEnvironmentSettings,
    cartItems : CartItem[],
    customAttributesValues : CustomAttributeValue[],
    catalog: POSCatalogData,
    orderSessionData: OrderSessionData,
    language: string,
  ) : Promise<CatalogOrderFileRoot | undefined> {

    if (catalog.catalogFileInfo === undefined) {
      return undefined;
    }

    console.log(`Generating order data for catalog: ${catalog.catalogFileInfo?.sourceData.catalogName}  lang=${language}`);
    // Create the file skeleton
    const orderData = new CatalogOrderFileRoot();
    orderData.orderSessionData = orderSessionData;

    orderData.orderID = uuidv4();

    // Channel and Catalog Info

    orderData.channelKey = catalog.catalogFileInfo.sourceData.channelKey;
    orderData.channelIsAuthenticationEnabled = catalog.catalogFileInfo.sourceData.channelIsAuthenticationEnabled;
    orderData.channelName = catalog.catalogFileInfo.sourceData.channelName;
    orderData.channelEmail = catalog.catalogFileInfo.sourceData.channelEmail;
    orderData.channelExternalRef = catalog.catalogFileInfo.sourceData.channelExternalRef;
    orderData.catalogKey = catalog.catalogFileInfo.sourceData.catalogKey;
    orderData.catalogName = catalog.catalogFileInfo.sourceData.catalogName;
    orderData.catalogRevision = catalog.catalogFileInfo.sourceData.catalogRevision;

    // Custom attributes
    orderData.orderCustomAttributesValues = customAttributesValues.map((customAttributeValue) => {
      // eslint-disable-next-line max-len
      const attributeDefinition = catalog.catalogFileInfo?.itemsCustomAttributesDefinitions.attributes.find((attDef) => { return customAttributeValue.attributeKey === attDef.key; });
      return {
        attributeKey: customAttributeValue.attributeKey,
        attributeName: customAttributeValue.attributeName,
        attributeValue: customAttributeValue.attributeValue,
        attributeTranslatedValue: customAttributeValue.attributeTranslatedValue,
        attributeQuantity: customAttributeValue.attributeQuantity,
        attributeBasePrice: customAttributeValue.attributeBasePrice,
        attributePriority: attributeDefinition?.priority || 0,
        attributeType: attributeDefinition?.type || 'unknown',
        attributeHasQuantity: attributeDefinition?.hasQuantity || false,
        attributeEnabled: customAttributeValue.attributeEnabled,
      };
    });

    // Items
    let lineID = 1;
    for (const cartItem of cartItems) {
      const catalogObject = catalog.modelsData.get(cartItem.catalogModelKey);
      if (!catalogObject) continue;

      const modelFilePath = FilePaths.join(
        environmentSettings.catalogInfoPath,
        catalogObject.getFileInfoPath(),
      );

      const newSLTXFile = new SLTXFile();
      newSLTXFile.setFilePath(modelFilePath);
      await newSLTXFile.openFile(catalogObject.getName());
      const catalogOrderFileItem = new CatalogOrderFileItem();

      // filter translations
      const modelTranslations = CatalogTagsTranslation.evalModelTranslations(
        cartItem.objectName,
        newSLTXFile.tagsTranslation,
      );

      // console.log(`Catalog translations for ${cartItem.objectName}:`, JSON.stringify(catalog.catalogFileInfo?.tagsTranslation));
      console.log(`Evaluated model translations for ${cartItem.objectName}:`, JSON.stringify(modelTranslations));

      // Line identification
      catalogOrderFileItem.lineNr = lineID;
      lineID++;

      // Item Identification
      catalogOrderFileItem.name = cartItem.objectName;
      catalogOrderFileItem.quantity = cartItem.quantity;

      catalogOrderFileItem.totalPrice = cartItem.totalPrice;
      catalogOrderFileItem.basePrice = cartItem.basePrice;

      catalogOrderFileItem.screenshotId = cartItem.screenshotId;
      catalogOrderFileItem.screenshotBase64 = cartItem.screenshotBase64;

      // Variant Name
      // First, try to determine if this combination is a known variant.
      // If it is not, send the last selected variant

      let variantName = POSOrderManager.getVariantName(
        catalog,
        cartItem,
      );

      if (variantName === '') {
        variantName = cartItem.lastVariantSelected;
      }

      catalogOrderFileItem.configuration.variantName = variantName;

      // Model Version control

      // const catalogObject = catalog.modelsData.get(cartItem.catalogModelKey);

      if (catalogObject
          && catalogObject.catalogData
          && catalogObject.catalogData.versionControl
      ) {
        catalogOrderFileItem.versionControl = catalogObject.catalogData.versionControl;
      }

      // Model composition
      cartItem.variant.forEach((variantPart) => {

        const newCatalogOrderFileItemOption = new CatalogOrderFileItemOption();

        newCatalogOrderFileItemOption.groupName = this.getModelGroupName(
          catalogObject,
          variantPart.groupID,
        );
        newCatalogOrderFileItemOption.groupID = variantPart.groupID;

        const groupTranslation = CatalogTagsTranslation.evalGroupTranslations(
          newCatalogOrderFileItemOption.groupName,
          modelTranslations,
        );
        // console.log(`Group translation for ${newCatalogOrderFileItemOption.groupName}:`, JSON.stringify(groupTranslation));

        // Now let's try to translate the group name
        newCatalogOrderFileItemOption.groupNameTranslated = CatalogTagsTranslation.getTranslation(
          CatalogTagsTranslation.getGroupTranslation(
            newCatalogOrderFileItemOption.groupName,
            groupTranslation,
          ),
          language,
        ) || newCatalogOrderFileItemOption.groupName;

        const optionNamesAndTranslation = this.getModelOptionName(
          catalogObject,
          variantPart.groupID,
          variantPart.optionID,
          groupTranslation,
          language,
        );

        newCatalogOrderFileItemOption.optionName = optionNamesAndTranslation.name;
        newCatalogOrderFileItemOption.optionNameTranslated = optionNamesAndTranslation.translatedName;

        newCatalogOrderFileItemOption.optionID = variantPart.optionID;

        newCatalogOrderFileItemOption.price = POSOrderManager.getModelOptionPrice(
          environmentSettings,
          cartItem.optionsPrice,
          catalogObject?.getName() || '',
          newCatalogOrderFileItemOption.groupName,
          newCatalogOrderFileItemOption.optionName,
        );
        if (newCatalogOrderFileItemOption.groupName !== '' && newCatalogOrderFileItemOption.optionName !== '') {
          catalogOrderFileItem.configuration.parts.push(newCatalogOrderFileItemOption);
        } else {
          console.error(`Attempting to add an empty/bogus option group (${variantPart.groupID};${variantPart.optionID}) `);
        }
      });
      // We'll need this to convert items custom attributes...
      // catalogObject?.data?.customAttributes
      // Model properties
      if (catalogObject !== undefined
        && catalogObject.catalogData !== undefined) {

        const itemCustomAttributes = new CatalogOrderFileItemCustomAttributesValues();

        // First add the item's onw custom attributes
        cartItem.objectCustomAttributes.forEach((att) => {
          // eslint-disable-next-line max-len
          const attributeDefinition = catalogObject.data?.customAttributes?.find((attDef) => { return att.attributeKey === attDef.key; });
          const attributeValue : CatalogOrderFileItemCustomAttributeValue = {
            attributeKey: att.attributeKey,
            attributeName: att.attributeName,
            attributeValue: att.attributeValue,
            attributeTranslatedValue: att.attributeTranslatedValue,
            attributeQuantity: att.attributeQuantity,
            attributeBasePrice: att.attributeBasePrice,
            attributePriority: attributeDefinition?.priority || 0,
            attributeType: attributeDefinition?.type || 'unknown',
            attributeHasQuantity: attributeDefinition?.hasQuantity || false,
            attributeEnabled: att.attributeEnabled,
          };
          // If this is an item extra, item augmentation whose quantity and price is independent from the item
          // Let's squize in the order attributes...otherwise including the Extendension attributes place in the
          // item's attr list (as originally placed)
          if (CustomAttributeData.isKeyFromClass(attributeValue.attributeKey, CustomAttributeClassPrefix.Extra)) {
            orderData.orderCustomAttributesValues.push(attributeValue);
          } else {
            itemCustomAttributes.attributesValues.push(attributeValue);
          }
        });

        // Then add the order line's  custom attributes
        cartItem.orderLineCustomAttributes.forEach((att) => {
          // eslint-disable-next-line max-len
          const attributeDefinition = catalog.catalogFileInfo?.itemsCustomAttributesDefinitions.attributes.find((attDef) => { return att.attributeKey === attDef.key; });
          const attributeValue : CatalogOrderFileItemCustomAttributeValue = {
            attributeKey: att.attributeKey,
            attributeName: att.attributeName,
            attributeValue: att.attributeValue,
            attributeTranslatedValue: att.attributeTranslatedValue,
            attributeQuantity: att.attributeQuantity,
            attributeBasePrice: att.attributeBasePrice,
            attributePriority: 99999 + (attributeDefinition?.priority || 0),
            attributeType: attributeDefinition?.type || 'unknown',
            attributeHasQuantity: attributeDefinition?.hasQuantity || false,
            attributeEnabled: att.attributeEnabled,
          };
          // If this is an item extra, item augmentation whose quantity and price is independent from the item
          // Let's squize in the order attributes...otherwise including the Extendension attributes place in the
          // item's attr list (as originally placed)
          if (CustomAttributeData.isKeyFromClass(attributeValue.attributeKey, CustomAttributeClassPrefix.Extra)) {
            orderData.orderCustomAttributesValues.push(attributeValue);
          } else {
            itemCustomAttributes.attributesValues.push(attributeValue);
          }
        });

        catalogOrderFileItem.customAttributesValues = itemCustomAttributes;

        let newEvaluatedProperties : EvaluatedProperties = [];
        const modelProps = catalogObject.getInfo();

        modelProps.forEach((prop) => {
          if (prop.metadataID) {
            newEvaluatedProperties.push({
              propertyID: prop.metadataID,
              value: prop.sectionInfo || '',
              valueFromRules: false,
            });
          }
        });

        // Get the active property rules
        const activeFilteringRules = catalogObject.catalogData.rules.filter((rule) => {
          return rule.enabled && rule.type === ModelRuleType.Properties;
        });

        // Go through all the rules and evaluate them
        activeFilteringRules.forEach((rule) => {

          if (catalogObject.data) {
            newEvaluatedProperties = RulesEvaluationProperties.evaluateRule(
              rule,
              cartItem.variant,
              catalogObject.data,
              newEvaluatedProperties,
            );
          }
        });

        // Save the evaluated properties in the order
        catalogOrderFileItem.itemProperties = newEvaluatedProperties;

        catalogOrderFileItem.itemMeasures = cartItem.objectDetails;
      }

      orderData.items.push(catalogOrderFileItem);
    }

    return orderData;
  }

  private static getModelGroupName(
    modelData : POSCatalogModelData | undefined,
    groupID : number,
  ) : string {

    if (modelData === undefined) {
      return '';
    }

    if (modelData.data === undefined
      || modelData.data.groups === undefined) {
      return '';
    }

    const modelGroup = modelData.data.groups.find((group) => group.id === groupID);
    if (modelGroup === undefined) {
      return '';
    }

    return modelGroup.name;
  }

  private static getModelOptionName(
    modelData : POSCatalogModelData | undefined,
    groupID : number,
    optionID : number,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
    language: string,
  ) : NameAndTranslation {

    if (modelData === undefined) {
      return { name: '', translatedName: '' };
    }

    if (modelData.data === undefined
      || modelData.data.groups === undefined) {
      return { name: '', translatedName: '' };
    }

    const modelGroup = modelData.data.groups.find((group) => group.id === groupID);
    if (modelGroup === undefined) {
      return { name: '', translatedName: '' };
    }

    // Go through all the folders of this group and find the one where this option is
    const folderThatContainsOption = modelGroup.optionsFolders.find((folder) => {
      return folder.options.find((option) => option.id === optionID) !== undefined;
    });

    if (folderThatContainsOption === undefined) {
      return { name: '', translatedName: '' };
    }

    // Grab the option definition that's inside that folder
    const optionDefinition = folderThatContainsOption.options.find(
      (option) => option.id === optionID,
    );

    if (optionDefinition === undefined) {
      return { name: '', translatedName: '' };
    }

    return {
      name: this.getOptionIdentifier(
        folderThatContainsOption.name,
        optionDefinition.name,
      ),
      translatedName: this.getOptionIdentifierTarnslation(
        folderThatContainsOption.name,
        optionDefinition.name,
        tagsTranslations,
        language,
      ),
    };
  }

  private static getOptionIdentifierTarnslation(
    folderName : string,
    optionName : string,
    tagsTranslations: CatalogTagsTranslation[] | undefined,
    language: string,
  ) : string {
    // If the folder name is 'Root', we should simply return the option name,
    // If the folder name is not 'Root', we should return the folder name + the option name

    if (folderName === SLTXDefaultFolderName) {
      return CatalogTagsTranslation.getTranslation(
        CatalogTagsTranslation.getRootOptionTranslation(
          optionName,
          tagsTranslations,
        ),
        language,
      ) || optionName;
    }

    const translatedFolder = CatalogTagsTranslation.getTranslation(
      CatalogTagsTranslation.getFolderTranslation(
        folderName,
        tagsTranslations,
      ),
      language,
    ) || folderName;

    const translatedOption = CatalogTagsTranslation.getTranslation(
      CatalogTagsTranslation.getFolderOptionTranslation(
        folderName,
        optionName,
        tagsTranslations,
      ),
      language,
    ) || optionName;

    return `${translatedFolder}+${translatedOption}`;
  }
  private static getOptionIdentifier(folderName : string, optionName : string) {
    // If the folder name is 'Root', we should simply return the option name,
    // If the folder name is not 'Root', we should return the folder name + the option name

    if (folderName === SLTXDefaultFolderName) {
      return optionName;
    }

    return `${folderName}+${optionName}`;
  }

  private static addCustomizationsFiles(
    zip: JSZip,
    cartItems : CartItem[],
    catalog: POSCatalogData,
    pickedFilesHandler : PickedFilesHandler,
  ) {

    cartItems.forEach((cartItem) => {

      const catalogObject = catalog.modelsData.get(cartItem.catalogModelKey);

      if (catalogObject) {

        const catalogObjectCustomizationConfiguration = catalogObject.customizations;
        if (catalogObjectCustomizationConfiguration
          && catalogObjectCustomizationConfiguration.customizations) {

          const arrCatalogObjectCustomizations = CustomizationConfiguration.getArrCustomizations(
            catalogObjectCustomizationConfiguration,
          );

          // Check if this item have customizations
          const cartItemCustomizations = CartItemHelper.GetCustomizations(cartItem);

          // Go through the object's customizations

          if (cartItemCustomizations && cartItemCustomizations.length > 0) {
            // This items have customizations
            // So, in the folder structure, we will have to have a folder for this item

            const customizationsFolder = zip.folder('customizations');

            if (customizationsFolder) {

              // Generate a folder name for this items customizations
              const cartItemIndex = `${CartItemHelper.GetCartIndex(cartItem)}`.padStart(
                4,
                '0',
              );

              // Create a folder for this item
              const cartItemCustomizationFolder = customizationsFolder.folder(
                `Item${cartItemIndex}`,
              );

              // Create a folder for this item's resources
              if (cartItemCustomizationFolder) {

                const cartItemCustomizationFolderResources = cartItemCustomizationFolder.folder('res');

                if (cartItemCustomizationFolderResources) {
                // Create an object to collect all the optimizations in a JSON
                  const customizationsOutputFile = new CustomizationsOutputFile();

                  let curFile = 1;

                  cartItemCustomizations.forEach(async (cartItemCustomizationValue) => {
                  // Get the customization ID
                    const customizationID = CustomizationValue.getCustomizationID(
                      cartItemCustomizationValue,
                    );
                    const partIdentifier = CustomizationValue.getPartIdentifier(
                      cartItemCustomizationValue,
                    );

                    // Get the customization Data
                    const customizationData = CustomizationValue.getData(
                      cartItemCustomizationValue,
                    );

                    const customizationTemplate = arrCatalogObjectCustomizations.find(
                      (customization) => {
                        return Customization.getID(customization) === customizationID;
                      },
                    );

                    if (customizationTemplate
                      && customizationData
                      && (Customization.getInputType(customizationTemplate)
                      === Customization.CustomizationTypeImage)
                    ) {
                    // This customization required a file to be selected.

                      // Grab the file ID
                      const fileID = CustomizationValueDataImage.getFileID(customizationData);

                      // Grab the file data retrieved from the picker
                      const fileHandler = pickedFilesHandler.getFile(fileID)!;

                      // Get the extension of the file
                      const pickedFileNameExtension = FileUtil.splitFileName(
                        fileHandler.name,
                      ).ext;

                      // Create a new unique name for this file in the res folder

                      const fileNameID = `${curFile}`.padStart(4, '0');
                      curFile++;

                      const fileNameInResFolder = `file${fileNameID}.${pickedFileNameExtension}`;

                      // Save the image file in the appropriate location

                      const fileContents = await readFileAsync(fileHandler);

                      cartItemCustomizationFolderResources.file(
                        fileNameInResFolder,
                        fileContents,
                        { base64: true },
                      );

                      // Add this customization to the file
                      customizationsOutputFile.addCustomizationImage(
                        partIdentifier,
                        customizationID,
                        `res/${fileNameInResFolder}`,
                      );
                    } else {
                    // eslint-disable-next-line no-console
                      console.warn(
                        'We\'re not capable of handling any other type at this stage...',
                      );
                    }
                  });

                  // Add the customizations JSON into the zip file
                  cartItemCustomizationFolder.file(
                    'customizations.json',
                    customizationsOutputFile.getContents(),
                  );
                }
              }
            }
          } // If customizations exist
        }
      }
    });
  }

  private static GenerateFileName(strings : Strings) {

    let fileName = `${strings.PRODUCTLIST}_${TimeUtil.getCurrentTimeAsStringSafe()}`;
    fileName = fileName.replaceAll(' ', '_');

    return fileName;
  }

  private static getVariantName(
    catalog : POSCatalogData,
    cartItem : CartItem,
  ) : string {

    const catalogObject = catalog.modelsData.get(cartItem.catalogModelKey);

    if (catalogObject === undefined
      || catalogObject.data === undefined
      || catalogObject.data.variants === undefined) {
      return '';
    }

    const variantDescription = POSCatalogModelData.GetVariantDescription(
      CartItemHelper.GetVariant(cartItem),
      catalogObject.data.variants,
    );

    return variantDescription;
  }
}
